import { render } from "./EditApropos.vue?vue&type=template&id=3afd39bb&ts=true"
import script from "./EditApropos.vue?vue&type=script&lang=ts"
export * from "./EditApropos.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__